import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import { useAuth } from '../../context/AuthContext'
import { database } from '../../firebase'
import { Button, ButtonTypes, MoContainer, MoSpan, MoLink, Alert, Flag, Input, MoTextArea } from '../../Mo7/mo7UI'
import { SUBSCRIPTION_STATES } from '../../services/data.service'
import { cols, icons } from '../../services/design.sevice'

export default function AnnouncementProfile() {
    const { announcement_id } = useParams()
    const { currentUser } = useAuth()
    const [announcement, setAnnouncement] = useState({})
    const [reviews, setReviews] = useState({})
    const [{ reviewText, stars }, setInputReview] = useState({ reviewText: "", stars: 0 })
    const [message, setMessage] = useState("")
    const [{ rank, rankStyle }, setRank] = useState({
        rank: "Bronze", rankStyle: `  linear-gradient(
            -72deg,
            #ca7345,
            #ffdeca 16%,
            #ca7345 21%,
            #ffdeca 24%,
            #a14521 27%,
            #ca7345 36%,
            #ffdeca 45%,
            #ffdeca 60%,
            #ca7345 72%,
            #ffdeca 80%,
            #ca7345 84%,
            #732100
          );`
    })
    const refTopPage = useRef()
    // anouncement
    useEffect(() => {
        return database.announcements.doc(announcement_id).get().then((doc) => {
            if (doc.exists) {
                setAnnouncement(database.formattedDoc(doc))
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document announcement!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

    }, [announcement_id])


    //Reviews
    useEffect(() => {
        return database.reviews.doc(announcement.uid).get().then((doc) => {
            if (doc.exists) {
                setReviews(database.formattedDoc(doc).list)

                setInputReview({
                    reviewText: database.formattedDoc(doc)?.list?.[`${currentUser.uid}`]?.text,
                    stars: database.formattedDoc(doc)?.list?.[`${currentUser.uid}`]?.stars
                })
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document review!");

            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

    }, [announcement, announcement_id, currentUser.uid])

    //rank
    useEffect(() => {


        async function fetchData() {
            try {
                const docOriginal = await database.ranks.doc(announcement.uid).get()
                let doc = database.formattedDoc(docOriginal)

                if (doc) {
                   
                    //calculate based on stars
                    let stars = doc.stars
                    if (stars >= 0 && stars < 10)
                        setRank({
                            rank: "Bronze", rankStyle: `  linear-gradient(
                        -72deg,
                        #ca7345,
                        #ffdeca 16%,
                        #ca7345 21%,
                        #ffdeca 24%,
                        #a14521 27%,
                        #ca7345 36%,
                        #ffdeca 45%,
                        #ffdeca 60%,
                        #ca7345 72%,
                        #ffdeca 80%,
                        #ca7345 84%,
                        #732100
                      );`
                        })
                    else if (stars >= 10 && stars < 20)
                        setRank({
                            rank: "Silver", rankStyle: `  linear-gradient(
                        -72deg,
                        #dedede,
                        #ffffff 16%,
                        #dedede 21%,
                        #ffffff 24%,
                        #454545 27%,
                        #dedede 36%,
                        #ffffff 45%,
                        #ffffff 60%,
                        #dedede 72%,
                        #ffffff 80%,
                        #dedede 84%,
                        #a1a1a1
                      );`
                        })
                    else if (stars >= 20 && stars < 40)
                        setRank({
                            rank: "Golden", rankStyle: `  linear-gradient(
                    -72deg,
                    #ffde45,
                    #ffffff 16%,
                    #ffde45 21%,
                    #ffffff 24%,
                    #452100 27%,
                    #ffde45 36%,
                    #ffffff 45%,
                    #ffffff 60%,
                    #ffde45 72%,
                    #ffffff 80%,
                    #ffde45 84%,
                    #452100
                  );`
                        })
                    else if (stars >= 40)
                        setRank({
                            rank: "Platinum", rankStyle: `
                    linear-gradient(
                        -72deg,
                        #dedeff,
                        #ffffff 16%,
                        #dedeff 21%,
                        #ffffff 24%,
                        #555564 27%,
                        #dedeff 36%,
                        #ffffff 45%,
                        #ffffff 60%,
                        #dedeff 72%,
                        #ffffff 80%,
                        #dedeff 84%,
                        #555564
                      ); 
                   `
                        })


                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document rank!")

                }
            } catch (error) {
                console.log("Error getting document rank:", error)
            }
        }
        fetchData()
   
    }, [announcement.uid])

    // const [width] = useWindowSize()
    // let isMobile = width < 980;

    function scrollToTopPage() {
        refTopPage?.current.scrollIntoView({
            behavior: "smooth"
        })
    }

    function handleInputReview(name, value) {
        setInputReview(prev => ({
            ...prev, [name]: value
        }
        ))

    }
    function handleSubmitReview(e) {
        console.log("erz")
        e.preventDefault()
        try {
            const revs = {
                ...reviews,
                [currentUser.uid]: {
                    photoURL: currentUser.photoURL,
                    displayName: currentUser.displayName,
                    stars: parseInt(stars),
                    text: reviewText,
                }
            }
            database.reviews.doc(announcement.uid).set({
                list: revs
            }).then(() => {
                window.location.reload()
            })
        } catch {
            setMessage("Your Review Not Was Sent Successfuly :( ");
        }
    }

    async function handleSubscribe() {

        if (!currentUser) return console.log("You need to login !")
        if (currentUser.uid === announcement.uid) return setMessage("You can't message yourself XD !")

        //subscribe to this announcement
        const newSubs = {
            ...announcement.subscribers,
            [currentUser.uid]: {
                state: SUBSCRIPTION_STATES.REJECTED,
                displayName: currentUser.displayName
            }
        }
        try {

            await database.announcements.doc(announcement_id).update({
                subscribers: newSubs
            })
            setMessage("Your Request Was Sent Successfuly :) ,Check Your Subscription Group Chat")
        } catch {
            setMessage("Faileld To send Your Request :( ")
        }
    }

    //#region dom

    const domReviews = Object.entries(reviews).map(([key, value]) => {

        return (key !== currentUser?.uid) && <MoContainer key={key} gap="1rem" flex>
            <MoContainer bg_i={value?.photoURL} border={{ w: "5px", col: "#ddd" }} b_r={{ all: "5rem" }} wh="8rem" />
            <MoContainer gap="1rem" flex_c w="calc(100% - 10rem)" bg={cols.mainLight_1} pd={{ all: ".5rem" }} b_r={{ all: ".2rem" }}>
                <MoContainer flex>
                    <MoSpan m_r="2rem" f_size="1.2rem" f_w="bold" col={cols.main_blue} > {key === currentUser?.uid ? "You" : value?.displayName}  </MoSpan>
                    <img width="20px" alt="" src={icons.ic_star} />
                    <MoSpan f_size="1.2rem" f_w="bold" col={cols.golden} > x {value?.stars} </MoSpan>
                </MoContainer>
                <MoSpan f_size="1.2rem" col={cols.mainDark_black}>{value.text}</MoSpan>
            </MoContainer>
        </MoContainer>
    })

    //#endregion

    return (<MoContainer pos="relative" flow_y='scroll' flow_x="hidden" h="100vh" scroller={{ col: "#ddd" }}>
        {message.length > 0 && <MoContainer w="100%" z="10" flex align="center" justify="center" pos="fixed" pos_dir={{ b: "2rem" }}>
            <Alert info w="60%" >  {message} </Alert>
            <Alert success w="10%" onClick={function () { setMessage("") }}>  Ok </Alert>
            <Alert danger w="10%" onClick={function () { setMessage("") }}>  Cancel </Alert>
        </MoContainer>}
        {/* Navigate To Top Page */}
        <MoContainer onClick={scrollToTopPage} grid trfm="rotate(-90deg)" place="center" bg={cols.mainLight_1} eff_shdw={{ op: .3 }} pos="fixed" pos_dir={{ b: "1rem", r: "1.5rem" }} w="2rem" h="2rem" b_r={{ all: "2rem" }} z="3" >
            <img src={icons.ic_arrow_right} alt="" width="20px" />
        </MoContainer>

        {/* Navbar  */}
        <MoContainer bg="white" sdw={{ x: "-5px", y: 0, sprd: ".5rem", op: "rgba(0,0,0,0.35)" }} flex h="5.5rem" w="99vw" pos="fixed" z="1" >
            {/* Logo */}
            <MoContainer flex pd={{ l: "4rem" }} align="center">
                <img height="45px" src={icons.logo2} alt="" />
            </MoContainer>
            {/* Links */}
            <MoContainer gap="2rem" pd={{ r: "4rem", l: "2rem" }} m_l="auto" align="center" flex >
                <MoLink pd={{ tb: "10px", lr: '15px' }} col={cols.main_blue} to="/home">Home</MoLink>
                <MoLink eff_hover="true" b_r={{ all: "5px" }} pd={{ tb: "10px", lr: '15px' }} bg={cols.main_purple} col={cols.mainLight_1} to="/dashboard/messages">Messages</MoLink>
                <MoLink eff_hover="true" b_r={{ all: "5px" }} pd={{ tb: "10px", lr: '15px' }} bg={cols.green} col={cols.mainLight_1} to="/dashboard/home">Dashboard</MoLink>
            </MoContainer>
        </MoContainer>
        <div ref={refTopPage} />
        <MoContainer pd={{ t: "8rem" }} >
            {/* Info */}
            <MoContainer flex >
                {/* left */}
                <MoContainer w="30%" h="20rem" flex_c align="center" pd={{ lr: "1rem", tb: 0 }}>
                    <MoContainer flex_c place="center" wh="20rem" >
                        <MoContainer bg_i={announcement.photoURL} border={{ w: "5px", col: cols.main_purple }} b_r={{ all: "15px" }} h="100%" w="80%" />
                        <Flag bg_all={rankStyle} col={cols.mainDark_1} text={`${rank} Bolt`} h="1.5rem" w="fit-content" />
                    </MoContainer>
                </MoContainer>
                {/* rigt */}
                <MoContainer flex w="60%">
                    <MoContainer flex_c w="60%">
                        <MoSpan fs_mid col={cols.mainDark_1} f_w="bold">{announcement.displayName}</MoSpan>
                        <MoSpan f_size="1rem" col={cols.mainDark_1} f_w="bold">{announcement.headline}</MoSpan>
                        <MoContainer flex>
                            <Flag h="fit-content" bg={cols.greenSwamp} col={cols.mainLight_1} w="fit-content" text="📍 Location" />
                            <Flag h="fit-content" bg={cols.mainLight_1} col={cols.main_purple} w="fit-content" text={announcement.tutoringAdress} />
                        </MoContainer>
                        <MoContainer flex>
                            <Flag h="fit-content" bg={cols.greenSwamp} col={cols.mainLight_1} w="fit-content" text="💵 Price" />
                            <Flag h="fit-content" bg={cols.main_blue} col={cols.mainLight_1} w="fit-content" text={announcement.price + " $/hour"} />
                        </MoContainer>
                        <MoContainer flex wrap='wrap'>
                            <Flag h="fit-content" bg={cols.greenSwamp} col={cols.mainLight_1} w="fit-content" text="📚 Subject" />
                            <Flag isActive h="fit-content" w="fit-content" text={announcement.subject} />
                            {announcement?.subSubjects?.map((r, i) => {
                                return <Flag key={i} h="fit-content" disabled w="fit-content" text={r} />
                            })}
                        </MoContainer>
                        <MoContainer flex wrap='wrap'>
                            <Flag h="fit-content" bg={cols.greenSwamp} col={cols.mainLight_1} w="fit-content" text="👩‍🏫 Course Type" />
                            {announcement?.courseTypes?.map((r, i) => {
                                return <Flag key={i} h="fit-content" disabled w="fit-content" text={r} />
                            })}
                        </MoContainer>

                    </MoContainer>
                    <MoContainer m_r="2rem" grid place="center" m_l="auto" w="30">
                        {!announcement?.subscribers?.[currentUser.uid]
                            ? <MoContainer onClick={handleSubscribe} eff_shdw={{ col: cols.gray }} cursor='pointer' b_r={{ tr: "5rem", tl: "5rem", bl: "0", br: "5rem" }} pd={{ tb: "1rem", lr: "1.2rem" }}
                                sdw={{ x: 0, y: 0, sprd: "1rem", op: "rgba(0,0,0,0.5)" }} flex align="center" w="fit-content" h="4rem" bg={cols.green}>
                                <img width="20px" alt="" src={icons.ic_message} />
                                <MoSpan fs_sml col="white" f_w="bold">Subscribe</MoSpan>
                            </MoContainer>
                            : <MoContainer onClick={function () { setMessage('Your Request Was Sent') }} eff_shdw={{ col: cols.gray }} cursor='pointer' b_r={{ tr: "5rem", tl: "5rem", bl: "0", br: "5rem" }} pd={{ tb: "1rem", lr: "1.2rem" }}
                                sdw={{ x: 0, y: 0, sprd: "1rem", op: "rgba(0,0,0,0.5)" }} flex align="center" w="fit-content" h="4rem" bg={cols.gray}>
                                <img width="20px" alt="" src={icons.ic_message} />
                                <MoSpan fs_sml col="white" f_w="bold">Subscribe</MoSpan>
                            </MoContainer>
                        }

                    </MoContainer>


                </MoContainer>
            </MoContainer>

            {/* CV */}
            {announcement?.CV?.length > 0 && <MoContainer pd={{ l: "2rem" }}>
                <MoSpan> CV </MoSpan>
                <MoContainer gap="1rem" flex_c w="calc(100% - 10rem)" bg={cols.mainLight_1} pd={{ all: ".5rem" }} b_r={{ all: ".2rem" }}>
                    <MoSpan f_size="1.2rem" col={cols.mainDark_black}>{announcement?.CV}</MoSpan>
                </MoContainer>

            </MoContainer>

            }
            {/* Rank */}

            {/* Reviews */}
            <MoContainer pd={{ l: "2rem" }}>
                <MoSpan>  Reviews </MoSpan>
                {/* reviews container */}
                <MoContainer flex_c gap="1rem" pd={{ t: "4rem", b: "2rem" }}>
                    {/* add review */}

                    {announcement.uid !== currentUser?.uid && <form onSubmit={handleSubmitReview}>
                        <MoContainer gap="1rem" flex>
                            <MoContainer bg_i={currentUser?.photoURL} border={{ w: "5px", col: "#ddd" }} b_r={{ all: "5rem" }} wh="8rem" />
                            <MoContainer gap="1rem" flex_c w="calc(100% - 10rem)" bg={cols.mainLight_1} pd={{ all: ".5rem" }} b_r={{ all: ".2rem" }}>
                                <MoContainer flex>
                                    <MoSpan m_r="2rem" f_size="1.2rem" f_w="bold" col={cols.main_blue} >You </MoSpan>
                                    <img width="20px" alt="" src={icons.ic_star} />
                                    <Input min={0} max={5} value={stars} onChange={(e) => handleInputReview("stars", e.target.value)} type="number" pholder="stars nubmer" />
                                </MoContainer>
                                <MoTextArea h="5rem" value={reviewText} onChange={(e) => handleInputReview("reviewText", e.target.value)} border={{ w: "1px", col: cols.main_blue }} w="100%" />
                            </MoContainer>
                        </MoContainer>
                        <MoContainer flex pd={{ l: "10rem", t: '1rem' }}>
                            <Button title={reviews?.[currentUser.uid] ? "Update" : "Submit"} type={ButtonTypes.success} pd={{ ub: "10px", lr: "20px" }} />
                        </MoContainer>
                    </form>}

                    {/* reviews */}
                    {reviews?.[currentUser.uid] &&

                        <MoContainer key={reviews?.[currentUser.uid]} gap="1rem" flex>
                            <MoContainer bg_i={reviews?.[currentUser.uid]?.photoURL} border={{ w: "5px", col: "#ddd" }} b_r={{ all: "5rem" }} wh="8rem" />
                            <MoContainer gap="1rem" flex_c w="calc(100% - 10rem)" bg={cols.mainLight_1} pd={{ all: ".5rem" }} b_r={{ all: ".2rem" }}>
                                <MoContainer flex>
                                    <MoSpan m_r="2rem" f_size="1.2rem" f_w="bold" col={cols.main_blue} >You</MoSpan>
                                    <img width="20px" alt="" src={icons.ic_star} />
                                    <MoSpan f_size="1.2rem" f_w="bold" col={cols.golden} > x {reviews?.[currentUser.uid]?.stars} </MoSpan>
                                </MoContainer>
                                <MoSpan f_size="1.2rem" col={cols.mainDark_black}>{reviews?.[currentUser.uid]?.text}</MoSpan>
                            </MoContainer>
                        </MoContainer>
                    }

                    {domReviews}
                </MoContainer>
            </MoContainer>
        </MoContainer>

    </MoContainer >
    )
}

        // <MoContainer flex flex_dir_c>
        //     <MoContainer >
        //         <MoSpan fs_mid col={cols.mainDark_1}> Tutor : </MoSpan>
        //         <MoSpan fs_mid > {announcement.displayName} </MoSpan>
        //     </MoContainer>
        //     <MoContainer >
        //         <MoSpan fs_mid col={cols.mainDark_1}> Subject : </MoSpan>
        //         <MoSpan fs_mid > {announcement.subject} </MoSpan>
        //     </MoContainer>
        //     <MoContainer >
        //         <MoSpan fs_mid col={cols.mainDark_1}> Headline : </MoSpan>
        //         <MoSpan fs_mid > {announcement.headline} </MoSpan>
        //     </MoContainer>
        //     <MoContainer >
        //         <MoSpan fs_mid col={cols.mainDark_1}> Price : </MoSpan>
        //         <MoSpan fs_mid col={cols.red}> {announcement.price}$/h </MoSpan>
        //     </MoContainer>
        //     {/* Message */}
        //     <MoContainer flex >
        //         <Button onClick={handleMessage} type={ButtonTypes.shadowed} title='Subscribe' />
        //     </MoContainer>
        // </MoContainer>